import React from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { logout } from 'redux/reducers/user';

import styles from './styles.scss';

@connect(
  state => ({
    profile: state.getIn(['user', 'profile']) || Map(),
  }),
  {
    logout,
  }
)
export default class Profile extends React.PureComponent {
  render() {
    const { profile } = this.props;

    return (
      <div className={styles.profile}>
        <div>
          <strong>name</strong>: {profile.get('fullname')}
        </div>
        <div>
          <strong>email</strong>: {profile.get('email')}
        </div>

        <button onClick={this.props.logout}>{kroostApp.strings.logout2}</button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/profile/index.js